import { useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";

const featuresData = {
  en: [
    {
      id: "01",
      title: "feature_1",
      accent: "amber",
    },
    {
      id: "02",
      title: "feature_2",
      accent: "teal",
    },
    {
      id: "03",
      title: "feature_3",
      accent: "amber",
    },
    {
      id: "04",
      title: "feature_4",
      accent: "teal",
    },
    {
      id: "05",
      title: "feature_5",
      accent: "amber",
    },
    {
      id: "06",
      title: "feature_6",
      accent: "teal",
    }
  ],

  th: [
    {
      id: "01",
      title: "feature_1",
      accent: "amber",
    },
    {
      id: "02",
      title: "feature_2",
      accent: "teal",
    },
    {
      id: "03",
      title: "feature_3",
      accent: "amber",
    },
    {
      id: "04",
      title: "feature_4",
      accent: "teal",
    },
    {
      id: "05",
      title: "feature_5",
      accent: "amber",
    },
    {
      id: "06",
      title: "feature_6",
      accent: "teal",
    }
  ],

  ph: [
    {
      id: "01",
      title: "feature_1",
      accent: "amber",
    },
    {
      id: "02",
      title: "feature_2",
      accent: "teal",
    },
    {
      id: "03",
      title: "feature_3",
      accent: "amber",
    },
    {
      id: "04",
      title: "feature_4",
      accent: "teal",
    },
    {
      id: "05",
      title: "feature_5",
      accent: "amber",
    },
    {
      id: "06",
      title: "feature_6",
      accent: "teal",
    },
    {
      id: "07",
      title: "feature_7",
      accent: "teal",
    }
  ],
};

function useInView(threshold = 0.15) {
  const ref = useRef(null);
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const el = ref.current;
    if (!el) return;

    const obs = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) setVisible(true);
      },
      { threshold }
    );

    obs.observe(el);

    return () => obs.disconnect();
  }, []);

  return [ref, visible];
}

function FeatureCard({ feature, index }) {
  const { t } = useTranslation();
  const [ref, visible] = useInView();

  const delay = `${index * 80}ms`;

  return (
    <div
      ref={ref}
      className={`bf-card bf-card--${feature.accent} ${
        visible ? "bf-card--in" : ""
      }`}
      style={{ animationDelay: delay }}
    >
      <div className="bf-card__id">{feature.id}</div>

      <div className="bf-card__body">
        <h3 className="bf-card__title">{t(feature.title)}</h3>
      </div>

      <div className="bf-card__line" />
    </div>
  );
}

export default function BenefitsSection({ language = "en" }) {
  const { t } = useTranslation();

  const [heroRef, heroVisible] = useInView(0.1);

  // language wise features
  const features = featuresData[language] || featuresData.en;

  return (
    <section className="bf-root">
      <div className="bf-grid-bg" aria-hidden="true" />

      <div
        ref={heroRef}
        className={`bf-hero ${heroVisible ? "bf-hero--in" : ""}`}
      >
        <h2 className="bf-hero__heading">
          {t("Features &")}
          <span className="bf-hero__highlight">
            {t("and Benefits")}
          </span>
        </h2>
      </div>

      <div className="bf-cards">
        {features.map((f, i) => (
          <FeatureCard key={f.id} feature={f} index={i} />
        ))}
      </div>
    </section>
  );
}